class StickyHeader extends HTMLElement {
  constructor() {
    super();

    this.lastScrollTop=0;
    this.mountedDrawers= [
      ".menu_drawer > summary",
      ".account_drawer > summary"
    ]

    if(this.hasAttribute("sticky")) window.addEventListener("scroll", this.stickHeader.bind(this));

    this.mountedDrawers.forEach((drawer)=> this.drawerAnimation(this.querySelector(drawer)))
    this.querySelectorAll(".menu details > summary").forEach(element => this.menuItemsDropdownStyling(element));
    this.drawersDropdownStyling(this.querySelector(".account_drawer > summary"));
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    window.addEventListener('resize', this.onResize );
  }

  stickHeader(event) {
    const st = window.pageYOffset || document.documentElement.scrollTop;
    if(!this.querySelector(".menu_drawer")?.hasAttribute("open")) st > this.lastScrollTop?this.parentElement.classList.add("menu-hidden"):this.parentElement.classList.remove("menu-hidden");
    this.lastScrollTop = st <= 0 ? 0 : st;
  }

  drawerAnimation(element, speed = 500) {
    if(!element) return;
    element.addEventListener("click", (e)=>{
      if(document.documentElement.clientWidth < parseInt(element.getAttribute("data-breakpoint") || 9999)){
        const main= document.querySelector("main");
        main.classList.add("shadow");
        document.body.classList.add("no-scroll");
        e.preventDefault();
        if(element.parentElement.hasAttribute("open")){
          const state= element.parentElement.getAttribute("open")
          if(state) return;
          main.classList.add("closing");
          element.parentElement.setAttribute("open", "closing")
          setTimeout(function(){
            main.classList.remove("shadow");main.classList.remove("closing");
            document.body.classList.remove("no-scroll");
            element.parentElement.removeAttribute("open");
          }, parseInt(element.getAttribute("data-animation-timeout")));
        }else{
          element.parentElement.setAttribute("open", "opening")
          setTimeout(function(){
            element.parentElement.setAttribute("open","");
          }, 1);
          this.mountedDrawers.forEach(otherDrawer => {
            const secondary_element= document.querySelector(otherDrawer);
            if(secondary_element && element != secondary_element && secondary_element.parentElement.hasAttribute("open")){
              secondary_element.parentElement.setAttribute("open", "closing")
              setTimeout(function(){
                secondary_element.parentElement.removeAttribute("open");
              }, parseInt(secondary_element.getAttribute("data-animation-timeout")));
            }
          })
        }
      }else{e.preventDefault()}
    })
  }

  menuItemsDropdownStyling(element) {
    if(!element) return;
    element.addEventListener("click", (e)=>{e.preventDefault()}) 
    element.parentElement.addEventListener("mouseenter", (e)=>{
      if(!element.parentElement.hasAttribute("open")){
        if(!element.parentElement.classList.contains("menu_drawer-body-main-item-sub")){
          document.body.classList.add("no-scroll");
          document.querySelector("main").classList.add("shadow")
        }
        element.parentElement.setAttribute("open", "")
      }
    })
    element.parentElement.addEventListener("mouseleave", (e)=>{
      if(element.parentElement.hasAttribute("open")){
        if(!element.parentElement.classList.contains("menu_drawer-body-main-item-sub")){
          document.body.classList.remove("no-scroll");
          document.querySelector("main").classList.remove("shadow")
        }
        element.parentElement.removeAttribute("open")
      }
    })
  }

  drawersDropdownStyling(element) {
    if(!element) return;
    element.parentElement.addEventListener("mouseenter", (e)=>{
      if(document.documentElement.clientWidth >= parseInt(element.getAttribute("data-breakpoint") || "0") && !element.parentElement.hasAttribute("open")){
        document.body.classList.add("no-scroll");
        document.querySelector("main").classList.add("shadow")
        element.parentElement.setAttribute("open", "")
      }
    })
    element.parentElement.addEventListener("mouseleave", (e)=>{
      if(document.documentElement.clientWidth >= parseInt(element.getAttribute("data-breakpoint") || "0") && element.parentElement.hasAttribute("open")){
        document.body.classList.remove("no-scroll");
        document.querySelector("main").classList.remove("shadow")
        element.parentElement.removeAttribute("open")
      }
    })
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerBounds = {};

    this.setHeaderHeight();

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));


    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }

  onResize() {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('sticky-header', StickyHeader);